// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1WOJT","productName":"Table_productName__1ssnM"};